(function Details($, Adzuki)
{
	"use strict";

	var $modal = $('.modal');

	Adzuki.onload(['HotelSheets/selectRooms', 'HotelSheets/settings', 'HotelSheets/modify', 'HotelSheets/review'], function onload() {
		$('.hotel-details-link').on('click', function showHotelDetails(e) {
			var giata_id = $(this).data('giata-id');

			e.preventDefault();
			$(".modal-dialog").addClass('modal-lg');

			Adzuki.Ajax.get('/HotelSheets/hotelDetails/' + giata_id).then(function success(data) {
				$modal.find('.modal-title').text('Hotel Details');
				$modal.find('.modal-body').html(data);

				$modal.on('hidden.bs.modal', function _restoreModal() {
					$modal.removeClass('wide').off('hidden.bs.modal');
				}).modal('show');
			});
		});

		$modal.on('click', '.ajax-image-gallery', function _showGallery(e) {
			var $el            = $(this),
				index          = parseInt($(this).data('index')),
				hotel_gallery  = null,
				giata_id       = $el.data('giata-id') || $el.parent().data('giata-id'),
				url            = '/HotelEngine/getGalleryImages/' + giata_id;
			
			$modal.modal('hide');

			Adzuki.Ajax.post(url).then(function sucess(response) {
				var images         = response;
				var gallery_images = [];

				if (images.length === 0) {
					return;
				}

				$.each(images, function onEachImage(i, image) {
					gallery_images.push({
						src    : image.src,
						thumb  : image.thumb,
						subHtml: image.subHtml,
					});
				});

				hotel_gallery = lightGallery($el[0], {
					licenseKey       : 'github',
					download         : false,
					plugins          : [lgThumbnail],
					dynamic          : true,
					thumbnail        : true,
					toggleThumb      : true,
					allowMediaOverlap: true,
					index            : index,
					dynamicEl        : gallery_images,
				});

				hotel_gallery.openGallery();
			});
		});
	});
}(jQuery, window.Adzuki || {}));
